import React from 'react';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/qFU1kPVn5zf4Ycwuoc7fqs/Mockup_-_SN26.webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-64" data-mp="9lbgj25n3de4">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-65" data-mp="4na1csbc3y7x" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-66" data-mp="1285x3nzc5smb">
        <p className="-mb-2 -mt-8 font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-67" data-mp="x9urjpg2q49w">
          🌿 BIOMA LÍVIDO™
        </p>
        <h1 className="mx-auto mt-5 max-w-5xl font-display text-2xl font-bold leading-[1.35] text-white sm:text-5xl lg:text-6xl" style={{
        fontSize: "18px"
      }} data-id="element-68" data-mp="s9giq56neqat">
          Ordená tu rutina y recuperá el equilibrio metabólico en 10 días,{' '}
          <span className="text-brand-light" data-id="element-69" data-mp="3825ywscu0bmf">
            sin dietas restrictivas ni prohibiciones.
          </span>
        </h1>
        <div className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-70" data-mp="3j925rpk1dsw2">
          <img src={mockupUrl} alt="Mockup del Protocolo Metabolismo en Equilibrio" width="1200" height="1200" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-71" data-mp="3o7vllomspvze" />
        </div>
        <div className="mx-auto max-w-2xl" data-id="element-72" data-mp="3e84odf6up2vm">
          <p className="-mb-2 font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-73" data-mp="3eb9150ydt6xw">
            PROTOCOLO METABOLISMO EN EQUILIBRIO™
          </p>
          <p className="-mb-4 mt-3 text-[13px] text-slate-200 sm:text-base" style={{
          fontSize: "14px"
        }} data-id="element-74" data-mp="35aawqhk16xes">
            Tu hoja de ruta en 5 volúmenes para identificar qué factores cotidianos interfieren con tu energía, tu hambre y tu bienestar diario.
          </p>
          <div className="-mb-5 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-75" data-mp="2hkgipwnz72sy">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-76" data-mp="2ljz0ijki2xrk">
              <FileTextIcon className="h-4 w-4 text-brand-light" data-id="element-77" data-mp="s3undmopqq5v" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-78" data-mp="ic89fikzqczf">
              <ZapIcon className="h-4 w-4 text-brand-gold" data-id="element-79" data-mp="ddww2xvhlkcg" />
              Acceso en 5 min
            </span>
          </div>
        </div>
        <div className="mx-auto mt-7 max-w-lg" data-id="element-80" data-mp="1b0duk6fyi3zs">
          <ActionButton href="#pricing" showTrust data-id="element-81" data-mp="1622kpvpnvthk">
            🌿 QUIERO MI PROTOCOLO AHORA
          </ActionButton>
        </div>
      </div>
    </section>;
}